/* Don't forget to add string 'products' to function combineReducers in './reducer.js' */
import { WP_API_BASE } from '../../shared/constants'
import * as _ from 'lodash'

const initialState = {
  isLoading: false,
  isLoaded: false,
  error: null,
  maxNumPages: 0,
  lastPost: '',
  posts: [],
  filters: {},
  strings: {},
  allEventsDates: {},
  hideKeywordSearch: false,
  content: '',
  perPage: 9,
  activePage: 1,
  activeFilters: {},
  hasFilters: false,
}

const LOAD_EVENTS_DATA = 'LOAD_EVENTS_DATA'
const UPLOAD_EVENTS_DATA = 'UPLOAD_EVENTS_DATA'
const LOAD_EVENTS_DATA_SUCCESS = 'LOAD_EVENTS_DATA_SUCCESS'
const LOAD_EVENTS_DATA_FAILURE = 'LOAD_EVENTS_DATA_FAILURE'

export default (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case LOAD_EVENTS_DATA:
      return {
        ...state,
        isLoading: true,
      }

    case LOAD_EVENTS_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        posts: [...payload.posts],
        activePage: payload.page,
        hasFilters: payload.hasFilters,
        activeFilters: payload.activeFilters,
        maxNumPages: parseInt(payload.maxNumPages),
      }

    case LOAD_EVENTS_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
      }

    case UPLOAD_EVENTS_DATA:
      return {
        ...state,
        posts: payload.data.posts,
        filters: payload.data.filters,
        lastPost: payload.data.lastPost,
        maxNumPages: parseInt(payload.data.maxNumPages),
        strings: payload.strings,
        content: payload.content,
        allEventsDates: payload.allEventsDates,
        hideKeywordSearch: payload.hideKeywordSearch,
      }

    default:
      return state
  }
}

export const loadPosts = (page, filters) => (dispatch /*, getState*/) => {
  dispatch({ type: LOAD_EVENTS_DATA })
  // Rest API Params
  // const { perPage } = getState().posts
  const perPage = 9
  const hasFilters = !_.isEmpty(filters)
  let params = {
    perPage: perPage,
    offset: (page - 1) * perPage,
  }
  if (hasFilters) {
    params = { ...params, ...filters }
  }

  let apiBaseUrl = WP_API_BASE
  const htmlLang = document.getElementsByTagName('html')[0].getAttribute('lang')

  let url_params = '/'
  if (params) {
    let i = 0
    for (let key in params) {
      params.hasOwnProperty(key)
        ? (url_params += (i === 0 ? '?' : '&') + key + '=' + params[key])
        : false
      i++
    }
  }
  if (htmlLang == 'de-de') {
    url_params = url_params + '&lang=de'
  } else if (htmlLang == 'en-us') {
    url_params = url_params + '&lang=en'
  }

  console.log('WORK') //eslint-disable-line
  console.log('request', `${apiBaseUrl}events${url_params}`) //eslint-disable-line

  return fetch(`${apiBaseUrl}events${url_params}`, {
    method: 'GET',
  })
    .then(response => {
      if (response.ok && response.status === 200) {
        console.log(response) //eslint-disable-line
        return response.json()
      }
      throw new Error(response.statusText)
    })
    .then(payload => {
      dispatch({
        payload: {
          posts: payload.posts,
          maxNumPages: payload.maxNumPages,
          page,
          hasFilters,
          activeFilters: filters,
        },
        type: LOAD_EVENTS_DATA_SUCCESS,
      })

      return payload
    })
    .catch(error => {
      if (process.env.NODE_ENV === 'development') {
        console.error(error) //eslint-disable-line
      }
      dispatch({
        error: error,
        type: LOAD_EVENTS_DATA_FAILURE,
      })
    })
}

export const uploadData = ({
  data,
  content,
  allEventsDates,
  strings,
  hideKeywordSearch,
}) => dispatch => {
  dispatch({
    payload: {
      strings,
      allEventsDates,
      data,
      content,
      hideKeywordSearch,
    },
    type: UPLOAD_EVENTS_DATA,
  })
}
